import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ReportsApi = createApi({
  reducerPath: "NewReports",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/reports`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getVehicleTrips: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/trips?from=${startdate}&to=${enddate}&${ids}&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getVehicleRoutes: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/route?from=${startdate}&to=${enddate}&${ids}&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getSummaryReports: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        selectedgroups: groupid,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/summary?from=${startdate}&to=${enddate}&${ids}${
          groupid ? `&${groupid}` : ""
        }&daily=true&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getStopReport: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/stops?from=${startdate}&to=${enddate}&${ids}&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getFuelReports: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        selectedgroups: groupid,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/summary?from=${startdate}&to=${enddate}&${ids}${
          groupid ? `&${groupid}` : ""
        }&daily=true&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
    getMaintenanceReports: builder.query({
      query: ({
        page,
        pageSize,
        sortBy,
        sortOrder,
        search,
        selectedgroups,
        selectedVehicles,
        dueWithin,
      }) => {
        const groupParams = selectedgroups ? `&${selectedgroups}` : "";
        const vehicleParams =
          selectedVehicles && selectedVehicles.length > 0
            ? selectedVehicles.map((id) => `vehicleId=${id}`).join("&")
            : "";
        const dueWithinParam =
          dueWithin !== "" && dueWithin !== null && dueWithin !== undefined
            ? `&dueWithin=${dueWithin}`
            : "";
        return `${process.env.REACT_APP_BACKEND3_URL}/reports/maintenance?page=${page}&limit=${pageSize}${
          groupParams ? `${groupParams}` : ""
        }${vehicleParams ? `&${vehicleParams}` : ""}${dueWithinParam}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`;
      },
    }),
  }),
});

export const {
  useGetVehicleTripsQuery,
  useLazyGetVehicleTripsQuery,
  useGetVehicleRoutesQuery,
  useLazyGetVehicleRoutesQuery,
  useGetStopReportQuery,
  useLazyGetStopReportQuery,
  useLazyGetSummaryReportsQuery,
  useGetSummaryReportsQuery,
  useLazyGetFuelReportsQuery,
  useLazyGetMaintenanceReportsQuery,
} = ReportsApi;
